import React from 'react';
import imageLogin from 'assets/img/image-login.png';
import NewDesign from 'components/NewDesign';
import useResponsive from 'hooks/useResponsive';
import classNames from 'classnames';
import { AppRoutes } from 'consts/routesPath';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useWebConfigs } from 'providers/WebConfigsProvider';
import getAuth from 'redux/selector/getAuth';
import { Redirect } from 'react-router';

const propTypes = {};

const LoginLayout = ({ children }) => {
  //! State
  const history = useHistory();
  const { isLogin } = getAuth();
  const { isMobile } = useResponsive();
  const { logo, logoMini, title, isTextback } = useWebConfigs();

  //! Function

  //! Render
  if (isLogin) {
    return <Redirect to={AppRoutes.HomePage} />;
  }

  return (
    <div className='component:LoginLayout login-layout d-flex h-100vh'>
      <div
        className={classNames(
          'login-layout__sidebar h-100 flex-shrink-0',
          isMobile ? 'd-none' : 'd-flex justify-content-between flex-column'
        )}
        style={{
          padding: 24,
          width: 360,
          background: isTextback
            ? `linear-gradient(to bottom, rgba(22, 119, 255, 0.7), rgba(22, 119, 255, 0.7)), url(${imageLogin}) lightgray 50% / cover no-repeat`
            : `linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(22,119,255,0.8) 50%, rgba(22,119,255,0.9) 100%)`,
          backgroundPosition: 'left',
        }}
        onClick={() => history.push(AppRoutes.HomePage)}
      >
        {isTextback ? (
          <div
            style={{ width: 40 }}
            className='d-flex gap-10px align-items-center hover:cursor-pointer'
          >
            <img
              src={logoMini}
              alt='logo'
              style={{ filter: isTextback ? 'invert(1)' : undefined }}
              className='w-100'
            />

            <NewDesign.Typography
              className='color-white-fixed'
              style={{ fontSize: 24, transform: isTextback ? 'translateY(-5px)' : undefined }}
            >
              {title}
            </NewDesign.Typography>
          </div>
        ) : (
          <img alt='logo' src={logo} />
        )}

        <div className='d-flex flex-column'>
          <NewDesign.Typography className='color-white-fixed text-caption-l-bold'>
            "SMS Marketing is <b style={{ textDecoration: 'line-through' }}>DEAD</b> the{' '}
            <b>FUTURE</b>!"
          </NewDesign.Typography>

          <NewDesign.Typography
            className='color-white-fixed mt-2 text-caption-l-regular'
            component='p'
          >
            ------ {title} Team
          </NewDesign.Typography>
        </div>
      </div>

      <div className='login-layout__content flex-grow-1'>{children}</div>
    </div>
  );
};

LoginLayout.propTypes = propTypes;
export default LoginLayout;
